import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { useSelector } from 'react-redux';
import FreePriceDisplayStyled from '../../../../components/merch-card/price-display/FreePriceDisplayStyled';
import { isUngatedForSeatsSelector } from '../../../../selectors/GatingSelectors';
import { BaseCardBadge } from '../../../components/merch-card/BaseCardBadge';
import { MerchCardLayoutUI } from '../../../components/MerchCardLayoutUI';
import { useIsInAppAuth } from '../../../hooks/user/useUserInfo';
import { FreeToolsPurchaseMotion } from '../../FreeToolsPurchaseMotion';
import { MerchCardSubheadingContainer } from '../headings-display/MerchCardSubheadingContainer';
import { MerchCardTitleContainer } from '../headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsMerchCard = ({
  HubDescription,
  Title,
  Features,
  trackingSource,
  columnStart = 1
}) => {
  const isInApp = useIsInAppAuth();
  const isSeatsRedesignUngated = useSelector(isUngatedForSeatsSelector);
  const Seats = isSeatsRedesignUngated ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.current"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.legacy"
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `free-tools-merch-card-${trackingSource}`,
    "data-selenium-id": `free-tools-merch-card-${trackingSource}`,
    columnStart: columnStart,
    Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
      Title: Title,
      Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
        apiName: FreeProducts.HUBSPOT_FREE
      })
    }),
    Subheading: /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
      apiName: FreeProducts.HUBSPOT_FREE,
      Subheading: HubDescription
    }),
    Pricing: /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FreePriceDisplayStyled, {})
    }),
    Seats: Seats,
    CTAs: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
      trackingSource: trackingSource,
      sourceId: "free-tools-merch-card",
      isInApp: isInApp
    }),
    Features: Features
  });
};